<template>
    
</template>
<script>
export default {
    name: 'y-preview'
}
</script>
<style lang="less">
@import "preview";
</style>


// WEBPACK FOOTER //
// preview.vue?22b71c7e